import BatchType from './BatchType';
export default BatchType;
